import { Link } from 'react-router-dom'
import { cn } from '../../lib/utils'

const OPEN_SIGNUP = import.meta.env.VITE_OPEN_SIGNUP !== 'false'

export const LandingNav = ({ scrolled }) => (
  <nav className={cn(
    'fixed top-0 inset-x-0 z-50 transition-all duration-300',
    scrolled
      ? 'bg-white/95 backdrop-blur-md border-b border-border shadow-sm'
      : 'bg-transparent',
  )}>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
      <a href="#top" className="font-display font-bold text-primary text-xl tracking-tight flex items-center gap-2 min-h-0 min-w-0">
        <span className="w-7 h-7 bg-primary rounded-lg flex items-center justify-center text-white text-xs font-bold">D</span>
        DoorChart
      </a>

      <div className="hidden sm:flex items-center gap-6 text-sm text-text-secondary">
        <a href="#features" className="hover:text-text-primary transition-colors">Features</a>
        <a href="#how-it-works" className="hover:text-text-primary transition-colors">How it works</a>
        <a href="#pricing" className="hover:text-text-primary transition-colors">Pricing</a>
        <a href="#faq" className="hover:text-text-primary transition-colors">FAQ</a>
      </div>

      <div className="flex items-center gap-2">
        <Link
          to="/login"
          className="text-sm text-text-secondary hover:text-text-primary px-3 py-2 min-h-0"
        >
          Sign in
        </Link>
        {OPEN_SIGNUP ? (
          <Link
            to="/signup"
            className="text-sm font-semibold bg-primary text-white px-4 py-2 rounded-xl hover:bg-primary/90 transition-colors shadow-sm min-h-0"
          >
            Start free
          </Link>
        ) : (
          <a
            href="#waitlist"
            className="text-sm font-semibold bg-primary text-white px-4 py-2 rounded-xl hover:bg-primary/90 transition-colors shadow-sm min-h-0"
          >
            Join waitlist
          </a>
        )}
      </div>
    </div>
  </nav>
)
